import React, {useEffect, useState,useRef} from "react";
import {useNavigate} from "react-router-dom";
import Styles from './index.module.scss'
import {hideLoading, showLoading} from "@/components/loading";
import {Toast, Input} from "antd-mobile";
import Service from "../service"
import {
  getPayParams,
  queryPayResult
} from "@/api/projectManager_self";
import { throttle} from "@/utils/publicFun";

/**
 * @description 新增申请页面
 * @return {/culturalExchange_greencarbon/addApply}
 */

const AddApply = () => {
  const navigate = useNavigate();
  const [exchangeAccount, setExchangeAccount] = useState('');
  const [quantity, setQuantity] = useState('');
  const [handlingFee, setHandlingFee] = useState('0.00');
  const [total, setTotal] = useState('0.00');
  const [payType, setPayType] = useState('wxpay'); // 默认选中微信
  const [availableQuantity, setAvailableQuantity] = useState(300);
  const [addinit, setAddinit] = useState({});
  const [placeholder, setPlaceholder] = useState('');
  const [usePoints, setUsePoints] = useState(true); // 是否使用积分抵扣，默认选中
  const [myPoints, setMyPoints] = useState(0); // 我的积分
  const [maxDeductPoints, setMaxDeductPoints] = useState(0); // 最多抵扣积分
  const [pointsRate, setPointsRate] = useState(100); // 100积分可抵扣1元
  const installedWX = useRef();

  useEffect(() => {
    if (window.JsBridge.hasWebViewBridge()) {
      window.JsBridge.nativeModules("UMShareModule", "isInstalledWx").then(
        function (res) {
          installedWX.current = res;
        }
      );
    }
  }, []);

  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    try {
      showLoading();
      // 这里可以调用接口获取可申请数量等信息
      const res = await Service.getAddInit();
      console.log('res===>', res)
      setAddinit(res.data);
      setPlaceholder(`数量不得少于${res.data.minNum}T`);
      // 从接口获取积分信息
      if (res.data?.userPoint) {
        setMyPoints(res.data.userPoint);
      }
      if (res.data?.maxPointUse) {
        setMaxDeductPoints(res.data.maxPointUse);
      }

      if(res.data?.switchFlag===1){
        setHandlingFee(res.data.price.toFixed(2));
        setUsePoints(true);
      } else {
        setUsePoints(false);
        setHandlingFee('0.00');
        setTotal('0.00');
      }
      
      hideLoading();
    } catch (error) {
      hideLoading();
      Toast.show(error);
    }
  }

  const handleBack = () => {
    navigate(-1);
  }

  // 计算积分抵扣金额
  const calculatePointsDeduction = (usePointsFlag = usePoints) => {
    if (!usePointsFlag) return 0;
    const deductionPoints = Math.min(maxDeductPoints, myPoints);
    return deductionPoints / pointsRate; // 100积分=1元
  }

  // 计算总计
  const calculateTotal = (usePointsFlag = usePoints) => {
    const fee = parseFloat(handlingFee) || 0;
    const pointsDeduction = calculatePointsDeduction(usePointsFlag);
    if(usePointsFlag){
      return Math.max(0, fee - pointsDeduction);
    } else {
      return Math.max(0, fee);
    }
  }

  const handleQuantityChange = (value) => {
    setQuantity(value);
    // 根据数量计算手续费和总计
    if (value && !isNaN(value) && parseFloat(value) >= parseFloat(addinit?.minNum)) {
      const fee = addinit.switchFlag==1?addinit.price:0;
      setHandlingFee(fee.toFixed(2));
      const totalAmount = calculateTotal();
      setTotal(totalAmount.toFixed(2));
    } else {
      setHandlingFee('');
      setTotal('');
    }
  }

  const handlePointsToggle = () => {
    const newUsePoints = !usePoints;
    setUsePoints(newUsePoints);
    // 使用新值直接计算总计
    const totalAmount = calculateTotal(newUsePoints);
    setTotal(totalAmount.toFixed(2));
  }

  // 当积分抵扣状态或手续费变化时，重新计算总计
  useEffect(() => {
    if (handlingFee) {
      const totalAmount = calculateTotal();
      setTotal(totalAmount.toFixed(2));
    }
  }, [usePoints, handlingFee]);

  const handlePayTypeChange = (type) => {
    setPayType(type);
  }
  const getPayResult = (params) => {
    try {
      showLoading();
      let timeId = setTimeout(async () => {
        const {code, msg} = await queryPayResult(params);
        hideLoading();
        if (code === '000000') {
          Toast.show({
            content: '支付成功',
            maskClickable: false,
            afterClose: () => {
              // onClose()
              // payCallback && payCallback()
              navigate(-1);
            }
          })
        } else {
          Toast.show(msg);
        }
        timeId && clearTimeout(timeId);
      }, 1500);
    } catch (error) {
      console.log(error);
    }
  }
  const pay = async (params) => {
    try {
      showLoading();
      const orderInfo = await Service.postConfirmSimpleOrder(params);
      if (orderInfo.code !== "000000") throw orderInfo.msg;
      if (total>0) {
        
      }else{
        hideLoading();
        return orderInfo.data;
      }
      const paramsInfo = await getPayParams({
        outTradeNo: orderInfo?.data?.outTradeNo || "",
      });
      hideLoading();
      if (paramsInfo.code !== "000000") throw paramsInfo.msg;
      return { ...paramsInfo.data, ...orderInfo.data };
    } catch (error) {
      hideLoading();
      Toast.show(error);
      return false;
    }
  };
  
  const handleSubmit = async () => {
    if (!exchangeAccount.trim()) {
      Toast.show('请输入交易所账户');
      return;
    }
    if (!quantity || parseFloat(quantity) < parseFloat(addinit?.minNum)) {
      Toast.show(placeholder);
      return;
    }
    if (!payType) {
      Toast.show('请选择支付方式');
      return;
    }
    try {
      const repayRes = await Service.getCarbonProductPrepaid();
      if (repayRes.code !== "000000") throw repayRes.msg;
      const {
        productId,
        defRepeatStr,
      } = repayRes.data || {};
      const jsonObject = {
        account:exchangeAccount,
        num:quantity,
      }
      const params = {
        totalNum: 1,
        totalUsePoint: addinit.switchFlag==0?0:Math.min(maxDeductPoints, myPoints),
        totalUseCash: total,
        payType: total > 0 ? (payType === 'alipay'?'ALIPAY':'WXPAY'):handlingFee>0?'POINT':'NONE',
        source: "app",
        uid: defRepeatStr,
        activityCode: 'CARBON_TRACE',
        type: '34',
        productId: productId,
        jsonObject,
      }
      const res = await pay(params);
      if (!res) {
        return;
      }
      if (total>0) {
        
      }else{
        getPayResult({ outTradeNo: res.outTradeNo });
        return;
      }
      // TODO 微信支付
      if (params.payType === "WXPAY") {
        if (!installedWX.current) {
          Toast.show("请先安装微信");
          return;
        }
        const result = await window.JsBridge.wxPay({
          partnerId: res.partnerId || "",
          prepayId: res.prepayId || "",
          nonceStr: res.nonceStr || "",
          timeStamp: res.timeStamp || "",
          sign: res.sign || "",
          appId: res.appId,
        });
        // 支付失败
        if (result.errCode === -2) {
          Toast.show({
            content: "支付取消",
            maskClickable: false,
            afterClose: () => {
              // onClose()
            }
          });
        } else if (result.errCode === 0) {
          // 支付回调
          let payParams = {
            errStr: result?.errStr,
            errCode: result?.errCode,
            outTradeNo: res.outTradeNo,
            source: "wxpay",
          };
          getPayResult(payParams);
        } else {
          Toast.show("支付发生错误  code: " + (result?.errCode || " "));
        }
      }
      // TODO 支付宝支付
      if (params.payType === "ALIPAY") {
        // 支付宝支付
        const payResult = res.payResult;
        const result = await window.JsBridge.aliPay(payResult);
        // 支付失败
        if (result.resultStatus == 6001) {
          Toast.show({
            content: "支付取消",
            maskClickable: false,
            afterClose: () => {
              // onClose()
            }
          });
        } else if (result.resultStatus == 62000) {
          Toast.show("客户端未安装支付通道依赖的服务");
        } else if (result.resultStatus == 9000) {
          // 支付回调
          let resFmt = JSON.parse(result.result || "{}");
          let payParams = {
            errStr: resFmt?.alipay_trade_app_pay_response?.msg || "",
            errCode: resFmt?.alipay_trade_app_pay_response?.code || "",
            outTradeNo: res.outTradeNo || "",
            source: "alipay",
          };
          getPayResult(payParams);
        } else {
          Toast.show("支付发生错误  code: " + (result?.resultStatus || " "));
        }
      }
    } catch (error) {
      console.log(error.msg||error)
      return;
    }
  }

  const throttlePayment = throttle(handleSubmit, 3000);

  return (
    <div className={Styles.addApply}>
      {/* 状态栏 */}
      <div className={Styles.statusBar}></div>

      {/* 导航栏 */}
      <div className={Styles.navBar}>
        <div className={Styles.backButton} onClick={handleBack}></div>
        <div className={Styles.title}>新增申请</div>
        <div className={Styles.placeholder}></div>
      </div>

      {/* 当前可领取数量 */}
      <div className={Styles.titleBox}>当前可领取数量: {addinit?.maxNum || 0}T</div>

      {/* 内容区域 */}
      <div className={Styles.content}>
        {/* 输入框卡片 */}
        <div className={Styles.inputCard}>
          <div className={Styles.inputRow}>
            <span className={Styles.inputLabel}>交易所账户</span>
            <Input
              className={Styles.input}
              placeholder="请输入"
              value={exchangeAccount}
              onChange={(val) => setExchangeAccount(val)}
            />
          </div>
          <div className={Styles.divider}></div>
          <div className={Styles.inputRow}>
            <span className={Styles.inputLabel}>数量</span>
            <Input
              className={Styles.input}
              placeholder={placeholder}
              value={quantity}
              onChange={handleQuantityChange}
              type="number"
            />
          </div>
        </div>
        <div className={Styles.tipText}>
          每个藏品为1t,输入数量后系统将随机选择对应数量的藏品
        </div>

        {/* 费用卡片 */}
        <div className={Styles.feeCard}>
          <div className={Styles.feeRow}>
            <span className={Styles.feeLabel}>手续费</span>
            <span className={Styles.feeValue}>¥{handlingFee}</span>
          </div>
          <div className={Styles.divider}></div>
          
          {/* 积分抵扣 */}
          <div className={Styles.pointsRow}>
            <div className={Styles.pointsLabelRow}>
              <span className={Styles.pointsLabel}>积分抵扣(最多抵扣{maxDeductPoints}积分)</span>
              <img 
                src={usePoints 
                  ? require('@/assets/img/culturalExchange_greencarbon/photeselected@2x.png')
                  : require('@/assets/img/culturalExchange_greencarbon/unselected.png')
                } 
                alt={usePoints ? '已选中' : '未选中'}
                className={Styles.pointsCheckbox}
                onClick={handlePointsToggle}
              />
            </div>
            <div className={Styles.pointsInfo}>
              我的积分:{myPoints}({pointsRate}积分可抵扣1元)
            </div>
          </div>
          <div className={Styles.divider}></div>
          
          <div className={Styles.feeRow}>
            <span className={Styles.feeLabel}>
              总计:{usePoints && calculatePointsDeduction() > 0 ? `积分抵扣:${Math.min(maxDeductPoints, myPoints)}(-¥${calculatePointsDeduction().toFixed(2)})` : ''}
            </span>
            <span className={Styles.feeValue}>¥{total || '0.00'}</span>
          </div>
        </div>

        {/* 支付方式卡片 */}
        <div className={Styles.payCard}>
          <div className={Styles.payTitle}>选择支付方式</div>
          <div className={Styles.divider}></div>
          <div className={Styles.payList}>
            <div 
              className={`${Styles.payItem} ${payType === 'alipay' ? Styles.selected : ''}`}
              onClick={() => handlePayTypeChange('alipay')}
            >
              <img 
                src={require('@/assets/img/culturalExchange_greencarbon/alipayicon@2x.png')} 
                alt="支付宝" 
                className={Styles.payIcon}
              />
              <span className={Styles.payName}>支付宝</span>
              <img 
                src={payType === 'alipay' 
                  ? require('@/assets/img/culturalExchange_greencarbon/selected.png')
                  : require('@/assets/img/culturalExchange_greencarbon/unselected.png')
                } 
                alt={payType === 'alipay' ? '已选中' : '未选中'}
                className={Styles.radioIcon}
              />
            </div>
            <div 
              className={`${Styles.payItem} ${payType === 'wxpay' ? Styles.selected : ''}`}
              onClick={() => handlePayTypeChange('wxpay')}
            >
              <img 
                src={require('@/assets/img/culturalExchange_greencarbon/wpayicon@2x.png')} 
                alt="微信" 
                className={Styles.payIcon}
              />
              <span className={Styles.payName}>微信</span>
              <img 
                src={payType === 'wxpay' 
                  ? require('@/assets/img/culturalExchange_greencarbon/selected.png')
                  : require('@/assets/img/culturalExchange_greencarbon/unselected.png')
                } 
                alt={payType === 'wxpay' ? '已选中' : '未选中'}
                className={Styles.radioIcon}
              />
            </div>
          </div>
        </div>

        {/* 确认信息 */}
        <div className={Styles.confirmText}>
          <div>确认提交后</div>
          <div>我们将在10个工作日内完成转移,且<span className={Styles.highlightText}>藏品将被回收</span></div>
        </div>

        {/* 确认按钮 */}
        <div className={Styles.submitBtn} onClick={throttlePayment}>
          <img src={require('@/assets/img/culturalExchange_greencarbon/comfirm-btn@2x.png')} alt="确认提交并支付" />
        </div>
      </div>
    </div>
  )
}

export default AddApply
